module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "left": "10px",
      "right": "10px",
      "background-color": "#ddd"
    }
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Zamknij")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.media.filepath,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.media.filepath
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45a46418","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LargeMedia.vue
// module id = 442
// module chunks = 1